export const CRMRoles = [
  { name: "No CRM Access", value: 0 },
  { name: "CRM Access", value: 1 },
  { name: "CRM User Management", value: 2 },
];
